<section id="loggedin-wrap">
  <div class="loggedin-wrap-container">
    @if (isFullyLoggedIn === fullyLoggedInStateType.SUCCESS) {
      <div>
      </div>
    }

    @if (isFullyLoggedIn ===  fullyLoggedInStateType.NO_FULLY_LOGGED_IN) {
      <div class="container-error">
        <div>
          <div class="okta-custom-message py-20">
            {{'login.errors.message' | translate}}
          </div>
          <div class="text-center">
            <button class="btn btn--primary mr-10" (click)="retry()">{{'login.errors.retry' | translate}}</button>
            <button class="btn btn--outline-secondary"
            (click)="reconnect()">{{'login.errors.resign_in' | translate}}</button>
          </div>
        </div>
      </div>
    }

    @if (isFullyLoggedIn == fullyLoggedInStateType.PENDING) {
      <div>
      </div>
    }
  </div>
</section>
